import { VolumeSelectorProperties } from '@buy/components/VolumeComponentWrapper'
import { FLEXIBLE_VOLUME_COMPONENT_TYPE } from '@buy/constants/flexible-components'
import { OrderSummaryLine } from '@buy/state/order-summary/order-summary'
import { BuyPrice, BuyPricing } from '@buy/state/price'
import { BillingPeriod, BillingPeriodCouponPaymentPlanMapper } from '@common/constants'
import { CouponItem } from '@common/state/coupon/state'
import { isEmpty, isUndefined } from 'lodash-es'

export const remapPricingObject = (pricingInfo: BuyPrice, currencyCode: string, repriceCouponItems?: CouponItem[]) => {
    const finalPricingMap = new Map()
    let usagePrice // usagePrice will be shown regardless of the billing tenure
    const rePriceCouponDiscounts: Record<string, number> = {}
    if (pricingInfo[currencyCode]) {
        Object.keys(pricingInfo[currencyCode]).forEach((key) => {
            const tempPricingMap = new Map()
            Object.values(pricingInfo[currencyCode][key as keyof BuyPricing]).forEach((item, index) => {
                let itemPrice = item.price
                if (!isEmpty(repriceCouponItems) && index === 0) {
                    const rePriceValue = repriceCouponItems
                        ?.find(
                            (item2) => item2.paymentPlan === BillingPeriodCouponPaymentPlanMapper[key as BillingPeriod]
                        )
                        ?.priceChanges.find((item3) => item3.currency === currencyCode)
                    if (!isEmpty(rePriceValue)) {
                        itemPrice = rePriceValue?.value ?? 0
                        rePriceCouponDiscounts[key] = Math.abs(item.price - rePriceValue?.value)
                    }
                }
                tempPricingMap.set(item.max, itemPrice)
                if (!isUndefined(item.usagePrice) && item.usagePrice > 0) usagePrice = item.usagePrice
            })
            finalPricingMap.set(key, Object.fromEntries(tempPricingMap))
        })
    }
    const newObj = {
        allPrices: Object.fromEntries(finalPricingMap),
        rePriceDiscounts: rePriceCouponDiscounts,
        usagePrice,
    }
    return newObj
}

export const getPrice = (quantity: number, prices: Record<string, number>) => {
    if (!isEmpty(prices)) {
        const matchedKey = Object.keys(prices).find((item) => quantity <= Number(item))
        return matchedKey ? prices[matchedKey] : 0
    }
    return 0
}

export const getPriceTier = (quantity: number, prices: Record<string, number>) => {
    if (!isEmpty(prices)) {
        const matchedKey = Object.keys(prices).findIndex((item) => quantity <= Number(item))
        return matchedKey ? matchedKey + 1 : 0
    }
    return 0
}

export const getComponentType = (volumeSelector: VolumeSelectorProperties) => {
    if (!volumeSelector.quantityPerUnit && isEmpty(volumeSelector.customListValues))
        return FLEXIBLE_VOLUME_COMPONENT_TYPE.PLUSMINUS
    if (!isEmpty(volumeSelector.customListValues) || volumeSelector.quantityPerUnit)
        return FLEXIBLE_VOLUME_COMPONENT_TYPE.DROPDOWN
    return null
}

export const calculateVolumeDiscount = (
    line: OrderSummaryLine,
    multiplier: number,
    billingPeriodKeys: string[],
    isAnnual: boolean
) => {
    const months = isAnnual ? 12 : 1
    const leftToggleBillingPeriod = billingPeriodKeys.find((item) => item !== BillingPeriod.ANNUAL)!

    const pricingInfo = line.allPrices[isAnnual ? BillingPeriod.ANNUAL : leftToggleBillingPeriod]
    const baseVolumePrice = getPrice(1, pricingInfo) * multiplier * months
    const currentVolumePrice = getPrice(multiplier, pricingInfo) * multiplier * months
    return baseVolumePrice - currentVolumePrice
}
